import styled from "@emotion/styled";

const Divider = styled.div`
  margin-left: 1rem;
  margin-right: 1rem;
  height: 1rem;
  width: 1px;
  background-color: ${({ theme }) => theme.colors.tone.silver};
`;

/* eslint-disable no-underscore-dangle */
const Div = styled.footer`
  padding: 20px 0;
  color: ${({ theme }) => theme.colors.tone.anthraciteLight};
  background-color: ${({ theme }) => theme.colors.tone.marble};
  .container {
    max-width: 1264px;
    margin: 0 auto;
    padding: 30px 20px 0;
    padding-top: 5px;
    text-align: left;

    .otrium-features {
      margin: 0 0 30px;
      padding-bottom: 10px;
      ul {
        margin: 0;
        padding: 0;
        list-style-type: none;
        li {
          display: inline-flex;
          align-items: center;
          color: ${({ theme }) => theme.colors.tone.anthracite};
          font-size: ${({ theme }) => theme.fontSizes.fontSize14};
          letter-spacing: 0.02rem;
          width: 100%;

          svg {
            width: 24px;
            height: 24px;
            flex-shrink: 0;

            path {
              stroke: ${({ theme }) => theme.colors.primary.gold};
            }
          }

          > span {
            margin-left: 10px;
          }
        }
      }
    }

    .otrium-payment {
      display: flex;
      border-top: 1px solid ${({ theme }) => theme.colors.tone.silver};
      border-bottom: 1px solid ${({ theme }) => theme.colors.tone.silver};
      padding: 20px 0;
      .otrium-payment-logos {
        flex: 1 80%;
      }
      .hidden-mobile {
        display: none;
      }
      img {
        max-height: 30px;
        padding: 0;
      }
    }

    .flex-justify {
      display: flex;
      flex-flow: row wrap;
      align-items: center;
      justify-content: space-evenly;
    }

    .flex-evenly {
      display: flex;
      align-items: center;
      justify-content: center;
      flex: 1;
    }

    .otrium-payment-mark {
      justify-content: flex-end;
      border-bottom: 0;
      flex: 1 20%;

      a {
        width: fit-content;
        color: ${({ theme }) => theme.colors.tone.anthraciteLight};
        margin-right: 1rem;
        &:last-of-type {
          margin-right: 0;
        }
        img {
          &:last-of-type {
            margin-right: 0;
          }
        }
      }

      .thuiswinkel-waarborg-logo {
        display: block;
        border-left: 1px solid ${({ theme }) => theme.colors.tone.silver};
        padding-left: 20%;
        margin-left: 20%;
      }
    }

    .footer-copyright-3 {
      font-size: 13px;
      padding: 16px 0 0;
      color: ${({ theme }) => theme.colors.tone.anthraciteLight};

      a {
        color: ${({ theme }) => theme.colors.tone.anthraciteLight};
        padding: 8px 0;
        margin: 0 16px;
        font-size: ${({ theme }) => theme.fontSizes.fontSize12};
        letter-spacing: 0.005rem;
        &:last-of-type {
          margin-right: 0;
        }
        &:hover {
          text-decoration: underline;
        }
      }
      .footer-copyright-text-logo {
        display: none;
        margin-right: auto;
      }
    }
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints[1]}) {
    .container {
      .otrium-features {
        ul {
          li {
            width: 50%;
          }
        }
      }
    }
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints[2]}) {
    .container {
      .otrium-payment {
        img {
          max-height: 40px;
        }
      }
      .otrium-payment-mark {
        display: none;
      }
    }
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints[2]}) {
    .container {
      .flex-justify {
        justify-content: space-between;
      }
      .otrium-payment {
        .hidden-mobile {
          display: flex;
          flex: 1 20%;
          justify-content: flex-end;
        }
      }
      .otrium-features {
        ul {
          display: flex;
          flex-flow: row nowrap;
          justify-content: space-between;
          li {
            width: auto;
            justify-content: flex-start;
            text-align: left;
            line-height: 3rem;
            &:before {
              width: 60px;
            }
            &:nth-of-typed(even) {
              text-align: left;
              justify-content: flex-start;
            }
          }
        }
      }
      .footer-copyright-3 {
        a {
          font-size: ${({ theme }) => theme.fontSizes.fontSize14};
        }
        .footer-copyright-text-logo {
          display: flex;
          align-items: center;
        }
        .footer-copyright-text {
          padding-left: 8px;
        }
      }
    }
  }
`;

const StyledFooterSeoText = styled.div`
  > div {
    border-bottom: 1px solid ${({ theme }) => theme.colors.tone.silver};
    padding: 24px 0;

    h1,
    h2,
    h3 {
      font-weight: 600;
      text-transform: none;
      color: ${({ theme }) => theme.colors.tone.anthraciteLight};
    }

    h1 {
      font-size: 1.4em;
    }

    h2,
    h3 {
      font-size: 1.2em;
      margin-top: 16px;
    }

    p {
      margin-top: 16px;
      line-height: 1.5;
      font-size: 13px;
      color: ${({ theme }) => theme.colors.tone.anthraciteLight};
    }
  }
`;

export { Div, Divider, StyledFooterSeoText };
